var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInjuryBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 107,
    viewBox: "0 0 90 107",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.268 106.184c2.067-4.551 3.1-12.113 3.1-22.685 0-10.467-6-32.98-18.002-67.538L1 14.911 33.336 1h23.56L89.23 14.91l-.365 1.051C76.864 50.52 70.863 73.031 70.863 83.5c0 10.572 1.034 18.134 3.1 22.685H16.269z",
    fill: "#FC5A56",
    stroke: "#FC5A56",
    fillRule: "evenodd",
    opacity: 0.495
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjuryBack);
export default __webpack_public_path__ + "static/media/injury-back.303f3a71084df6e0bb90a69d0cdb6cfc.svg";
export { ForwardRef as ReactComponent };